var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { pre: true, attrs: { class: "chi-demos-wrapper" } }, [
    _c(
      "div",
      {
        pre: true,
        attrs: {
          class: "chi-demos-header",
          title: "Click to pin the ribbon open",
          "v-on:click": "onclick",
          "v-on:mousedown": "onmousedown",
          "v-on:mouseout": "onunhover",
          "v-on:mouseover": "onhover",
          "v-on:mouseup": "onmouseup"
        }
      },
      [
        _c("div", {
          pre: true,
          attrs: {
            "data-safe-id": "chi_chi_demos_summary",
            "data-properties":
              "{\n      'classes': ['chi-demos-summary'],\n      'style': {},\n      'hint': '',\n      'shared': true,\n      'value': 'Select Patient'\n    }",
            ":class": "components.chi_chi_demos_summary.classes",
            ":style": "components.chi_chi_demos_summary.style",
            ":title": "components.chi_chi_demos_summary.hint",
            ":value": "components.chi_chi_demos_summary.value",
            ":id": "'chi-demos-summary'",
            autocomplete: "off",
            readonly: "",
            ref: "chi-demos-summary",
            role: "readonlyfield",
            tabindex: "-1",
            "v-html": "components.chi_chi_demos_summary.value"
          }
        }),
        _c(
          "kendo-button",
          {
            pre: true,
            attrs: {
              "data-safe-id": "chi_chi_demos_search",
              "data-properties":
                "{\n      'classes': ['chi-demos-summary-button'],\n      'style': {},\n      'content': '',\n      'hint': 'Search patient accounts',\n      'icon': 'find',\n      'shared': true,\n      'send': 'chi-demos-search'\n      }",
              ":class": "components.chi_chi_demos_search.classes",
              ":icon": "components.chi_chi_demos_search.icon",
              ":style": "components.chi_chi_demos_search.style",
              ":title": "components.chi_chi_demos_search.hint",
              "v-on:click": "ondemobuttonclick",
              "data-send": "chi-demos-search",
              ":id": "'chi-demos-search'",
              ref: "chi-demos-search",
              role: "button"
            }
          },
          [
            _vm._v(
              "{{components.chi_chi_demos_search.content.replace(/ /g, '&nbsp;')}}"
            )
          ]
        ),
        _c(
          "kendo-button",
          {
            pre: true,
            attrs: {
              "data-safe-id": "chi_chi_demos_recent",
              "data-properties":
                "{\n      'classes': ['chi-demos-summary-button', 'recent'],\n      'style': {},\n      'content': '',\n      'hint': 'Select from recently-viewed patient accounts',\n      'icon': 'recent-patients',\n      'shared': true,\n      'send': 'chi-demos-recent'\n      }",
              ":class": "components.chi_chi_demos_recent.classes",
              ":icon": "components.chi_chi_demos_recent.icon",
              ":style": "components.chi_chi_demos_recent.style",
              ":title": "components.chi_chi_demos_recent.hint",
              "v-on:click": "ondemobuttonclick",
              "data-send": "chi-demos-recent",
              ":id": "'chi-demos-recent'",
              ref: "chi-demos-recent",
              role: "button"
            }
          },
          [
            _vm._v(
              "{{components.chi_chi_demos_recent.content.replace(/ /g, '&nbsp;')}}"
            )
          ]
        )
      ],
      1
    ),
    _c(
      "div",
      {
        pre: true,
        attrs: {
          class: "chi-demos-content",
          "v-on:mousedown": "onmousedown",
          "v-on:mouseout": "onunhover",
          "v-on:mouseup": "onmouseup"
        }
      },
      [
        _c("div", {
          pre: true,
          attrs: {
            "data-safe-id": "chi_chi_demos_picture",
            "data-properties":
              "{\n      'classes': ['chi-demos-picture'],\n      'style': {},\n      'file': 'RESOURCES/HTML/FMSGRAY.HTML',\n      'hint': '',\n      'shared': true,\n      'template': ''\n    }",
            ":class": "components.chi_chi_demos_picture.classes",
            ":style": "components.chi_chi_demos_picture.style",
            ":title": "components.chi_chi_demos_picture.hint",
            "v-on:click": "ondemolinkclick",
            ":id": "'chi-demos-picture'",
            ref: "chi-demos-picture",
            role: "htmlarea",
            "v-html": "components.chi_chi_demos_picture.template"
          }
        }),
        _c(
          "div",
          { pre: true, attrs: { class: "chi-form chi-demos-fields" } },
          [
            _c(
              "div",
              {
                pre: true,
                attrs: { class: "chi-form-group", style: "clear: left" }
              },
              [
                _c(
                  "label",
                  {
                    pre: true,
                    attrs: {
                      for: "chi-demos-pacct",
                      ":id": "'label-10-15-110-36'"
                    }
                  },
                  [_vm._v("Account")]
                ),
                _c("br"),
                _c("input", {
                  pre: true,
                  attrs: {
                    "data-safe-id": "chi_chi_demos_pacct",
                    "data-properties":
                      "{\n          'classes': ['k-textbox'],\n          'style': {\n            'width': '8.1428rem'\n          },\n          'hint': '',\n          'shared': true,\n          'value': ''\n        }",
                    ":class": "components.chi_chi_demos_pacct.classes",
                    ":maxlength": "components.chi_chi_demos_pacct.maxlength",
                    ":style": "components.chi_chi_demos_pacct.style",
                    ":title": "components.chi_chi_demos_pacct.hint",
                    ":value": "components.chi_chi_demos_pacct.value",
                    "v-on:keyup.enter": "$('#chi-demos-go').focus()",
                    ":id": "'chi-demos-pacct'",
                    autocomplete: "off",
                    ref: "chi-demos-pacct",
                    role: "textfield",
                    type: "text"
                  }
                }),
                _c(
                  "kendo-button",
                  {
                    pre: true,
                    attrs: {
                      "data-safe-id": "chi_chi_demos_go",
                      "data-properties":
                        "{\n          'classes': ['small'],\n          'style': {\n            'border-color': '#f6f6f6'\n          },\n          'content': '',\n          'hint': '',\n          'icon': 'go',\n          'send': 'chi-demos-go',\n          'shared': true\n        }",
                      ":class": "components.chi_chi_demos_go.classes",
                      ":icon": "components.chi_chi_demos_go.icon",
                      ":style": "components.chi_chi_demos_go.style",
                      ":title": "components.chi_chi_demos_go.hint",
                      "v-on:click": "ondemobuttonclick",
                      "data-send": "chi-demos-go",
                      ":id": "'chi-demos-go'",
                      ref: "chi-demos-go",
                      role: "button"
                    }
                  },
                  [
                    _vm._v(
                      "{{components.chi_chi_demos_go.content.replace(/ /g, '&nbsp;')}}"
                    )
                  ]
                )
              ],
              1
            ),
            _vm._m(0),
            _vm._m(1),
            _vm._m(2),
            _vm._m(3),
            _vm._m(4),
            _c(
              "div",
              {
                pre: true,
                attrs: {
                  class: "chi-form-group without-label",
                  style: "clear: left;"
                }
              },
              [
                _c(
                  "kendo-button",
                  {
                    pre: true,
                    attrs: {
                      "data-safe-id": "chi_chi_demos_contacts",
                      "data-properties":
                        "{\n          'classes': ['small'],\n          'style': {\n            'border-color': '#f6f6f6'\n          },\n          'content': '',\n          'hint': '',\n          'icon': 'address-book',\n          'shared': true\n        }",
                      ":class": "components.chi_chi_demos_contacts.classes",
                      ":icon": "components.chi_chi_demos_contacts.icon",
                      ":style": "components.chi_chi_demos_contacts.style",
                      ":title": "components.chi_chi_demos_contacts.hint",
                      "v-on:click": "on_menu_select",
                      ":id": "'jump-Demographics-wme0615-contacts'",
                      ref: "chi-demos-contacts",
                      role: "button"
                    }
                  },
                  [
                    _vm._v(
                      "{{components.chi_chi_demos_contacts.content.replace(/ /g, '&nbsp;')}}"
                    )
                  ]
                )
              ],
              1
            ),
            _vm._m(5),
            _vm._m(6),
            _vm._m(7),
            _vm._m(8),
            _vm._m(9)
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { pre: true, attrs: { class: "chi-form-group" } }, [
      _c(
        "label",
        {
          pre: true,
          attrs: { for: "chi-demos-name", ":id": "'label-120-85-240-106'" }
        },
        [_vm._v("Name")]
      ),
      _c("br"),
      _c("input", {
        pre: true,
        attrs: {
          "data-safe-id": "chi_chi_demos_name",
          "data-properties":
            "{\n          'classes': [\n            'k-textbox'\n          ],\n          'style': {\n            'color': 'rgb(76, 141, 224)',\n            'cursor': 'pointer',\n            'text-decoration': 'underline',\n            'width': '18rem'\n          },\n          'hint': '',\n          'shared': true,\n          'value': ''\n        }",
          ":class": "components.chi_chi_demos_name.classes",
          ":style": "components.chi_chi_demos_name.style",
          ":title": "components.chi_chi_demos_name.hint",
          ":value": "components.chi_chi_demos_name.value",
          "v-on:click": "on_menu_select",
          ":id": "'jump-Demographics-wme0615'",
          autocomplete: "off",
          readonly: "",
          ref: "chi-demos-name",
          role: "readonlyfield",
          type: "text"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { pre: true, attrs: { class: "chi-form-group" } }, [
      _c(
        "label",
        {
          pre: true,
          attrs: { for: "chi-demos-dob", ":id": "'label-120-85-240-106'" }
        },
        [_vm._v("DOB")]
      ),
      _c("br"),
      _c("input", {
        pre: true,
        attrs: {
          "data-safe-id": "chi_chi_demos_dob",
          "data-properties":
            "{\n          'classes': [\n            'k-textbox'\n          ],\n          'style': {\n            'width': '7.4285rem'\n          },\n          'hint': '',\n          'shared': true,\n          'value': ''\n        }",
          ":class": "components.chi_chi_demos_dob.classes",
          ":style": "components.chi_chi_demos_dob.style",
          ":title": "components.chi_chi_demos_dob.hint",
          ":value": "components.chi_chi_demos_dob.value",
          ":id": "'chi-demos-dob'",
          autocomplete: "off",
          readonly: "",
          ref: "chi-demos-dob",
          role: "readonlyfield",
          type: "text"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { pre: true, attrs: { class: "chi-form-group" } }, [
      _c(
        "label",
        {
          pre: true,
          attrs: { for: "chi-demos-age", ":id": "'label-120-85-240-106'" }
        },
        [_vm._v("Age")]
      ),
      _c("br"),
      _c("input", {
        pre: true,
        attrs: {
          "data-safe-id": "chi_chi_demos_age",
          "data-properties":
            "{\n          'classes': [\n            'k-textbox'\n          ],\n          'style': {\n            'width': '10.571rem'\n          },\n          'hint': '',\n          'shared': true,\n          'value': ''\n        }",
          ":class": "components.chi_chi_demos_age.classes",
          ":style": "components.chi_chi_demos_age.style",
          ":title": "components.chi_chi_demos_age.hint",
          ":value": "components.chi_chi_demos_age.value",
          ":id": "'chi-demos-age'",
          autocomplete: "off",
          readonly: "",
          ref: "chi-demos-age",
          role: "readonlyfield",
          type: "text"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { pre: true, attrs: { class: "chi-form-group" } }, [
      _c(
        "label",
        {
          pre: true,
          attrs: { for: "chi-demos-gender", ":id": "'label-120-85-240-106'" }
        },
        [_vm._v("Gender")]
      ),
      _c("br"),
      _c("input", {
        pre: true,
        attrs: {
          "data-safe-id": "chi_chi_demos_gender",
          "data-properties":
            "{\n          'classes': [\n            'k-textbox'\n          ],\n          'style': {\n            'width': '6.2142rem'\n          },\n          'hint': '',\n          'shared': true,\n          'value': ''\n        }",
          ":class": "components.chi_chi_demos_gender.classes",
          ":style": "components.chi_chi_demos_gender.style",
          ":title": "components.chi_chi_demos_gender.hint",
          ":value": "components.chi_chi_demos_gender.value",
          ":id": "'chi-demos-gender'",
          autocomplete: "off",
          readonly: "",
          ref: "chi-demos-gender",
          role: "readonlyfield",
          type: "text"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { pre: true, attrs: { class: "chi-form-group" } }, [
      _c(
        "label",
        {
          pre: true,
          attrs: { for: "chi-demos-phys", ":id": "'label-120-85-240-106'" }
        },
        [_vm._v("Primary Physician")]
      ),
      _c("br"),
      _c("input", {
        pre: true,
        attrs: {
          "data-safe-id": "chi_chi_demos_phys",
          "data-properties":
            "{\n          'classes': [\n            'k-textbox'\n          ],\n          'style': {\n            'width': '17.071rem'\n          },\n          'hint': '',\n          'shared': true,\n          'value': ''\n        }",
          ":class": "components.chi_chi_demos_phys.classes",
          ":style": "components.chi_chi_demos_phys.style",
          ":title": "components.chi_chi_demos_phys.hint",
          ":value": "components.chi_chi_demos_phys.value",
          ":id": "'chi-demos-phys'",
          autocomplete: "off",
          readonly: "",
          ref: "chi-demos-phys",
          role: "readonlyfield",
          type: "text"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { pre: true, attrs: { class: "chi-form-group" } }, [
      _c(
        "label",
        {
          pre: true,
          attrs: { for: "chi-demos-home", ":id": "'label-120-85-240-106'" }
        },
        [_vm._v("(H) Phone")]
      ),
      _c("br"),
      _c("input", {
        pre: true,
        attrs: {
          "data-safe-id": "chi_chi_demos_home",
          "data-properties":
            "{\n          'classes': [\n            'k-textbox'\n          ],\n          'style': {\n            'width': '8.0714rem'\n          },\n          'hint': '',\n          'shared': true,\n          'value': ''\n        }",
          ":class": "components.chi_chi_demos_home.classes",
          ":style": "components.chi_chi_demos_home.style",
          ":title": "components.chi_chi_demos_home.hint",
          ":value": "components.chi_chi_demos_home.value",
          ":id": "'chi-demos-home'",
          autocomplete: "off",
          readonly: "",
          ref: "chi-demos-home",
          role: "readonlyfield",
          type: "text"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { pre: true, attrs: { class: "chi-form-group" } }, [
      _c(
        "label",
        {
          pre: true,
          attrs: { for: "chi-demos-work", ":id": "'label-120-85-240-106'" }
        },
        [_vm._v("(W) Phone")]
      ),
      _c("br"),
      _c("input", {
        pre: true,
        attrs: {
          "data-safe-id": "chi_chi_demos_work",
          "data-properties":
            "{\n          'classes': [\n            'k-textbox'\n          ],\n          'style': {\n            'width': '8.0714rem'\n          },\n          'hint': '',\n          'shared': true,\n          'value': ''\n        }",
          ":class": "components.chi_chi_demos_work.classes",
          ":style": "components.chi_chi_demos_work.style",
          ":title": "components.chi_chi_demos_work.hint",
          ":value": "components.chi_chi_demos_work.value",
          ":id": "'chi-demos-work'",
          autocomplete: "off",
          readonly: "",
          ref: "chi-demos-work",
          role: "readonlyfield",
          type: "text"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { pre: true, attrs: { class: "chi-form-group", style: "" } },
      [
        _c(
          "label",
          {
            pre: true,
            attrs: { for: "chi-demos-cell", ":id": "'label-120-85-240-106'" }
          },
          [_vm._v("(M) Phone")]
        ),
        _c("br"),
        _c("input", {
          pre: true,
          attrs: {
            "data-safe-id": "chi_chi_demos_cell",
            "data-properties":
              "{\n          'classes': [\n            'k-textbox'\n          ],\n          'style': {\n            'width': '8.0714rem'\n          },\n          'hint': '',\n          'shared': true,\n          'value': ''\n        }",
            ":class": "components.chi_chi_demos_cell.classes",
            ":style": "components.chi_chi_demos_cell.style",
            ":title": "components.chi_chi_demos_cell.hint",
            ":value": "components.chi_chi_demos_cell.value",
            ":id": "'chi-demos-cell'",
            autocomplete: "off",
            readonly: "",
            ref: "chi-demos-cell",
            role: "readonlyfield",
            type: "text"
          }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { pre: true, attrs: { class: "chi-form-group" } }, [
      _c(
        "label",
        {
          pre: true,
          attrs: { for: "chi-demos-address", ":id": "'label-120-85-240-106'" }
        },
        [_vm._v("Address")]
      ),
      _c("br"),
      _c("input", {
        pre: true,
        attrs: {
          "data-safe-id": "chi_chi_demos_address",
          "data-properties":
            "{\n          'classes': [\n            'k-textbox'\n          ],\n          'style': {\n            'clear': 'left',\n            'width': '30.5rem'\n          },\n          'hint': '',\n          'shared': true,\n          'value': ''\n        }",
          ":class": "components.chi_chi_demos_address.classes",
          ":style": "components.chi_chi_demos_address.style",
          ":title": "components.chi_chi_demos_address.hint",
          ":value": "components.chi_chi_demos_address.value",
          ":id": "'chi-demos-address'",
          autocomplete: "off",
          readonly: "",
          ref: "chi-demos-address",
          role: "readonlyfield",
          type: "text"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { pre: true, attrs: { class: "chi-form-group" } }, [
      _c(
        "label",
        {
          pre: true,
          attrs: { for: "chi-demos-ins", ":id": "'label-120-85-240-106'" }
        },
        [_vm._v("Primary Insurance")]
      ),
      _c("br"),
      _c("input", {
        pre: true,
        attrs: {
          "data-safe-id": "chi_chi_demos_ins",
          "data-properties":
            "{\n          'classes': [\n            'k-textbox'\n          ],\n          'style': {\n            'width': '18.5rem'\n          },\n          'hint': '',\n          'shared': true,\n          'value': ''\n        }",
          ":class": "components.chi_chi_demos_ins.classes",
          ":style": "components.chi_chi_demos_ins.style",
          ":title": "components.chi_chi_demos_ins.hint",
          ":value": "components.chi_chi_demos_ins.value",
          ":id": "'chi-demos-ins'",
          autocomplete: "off",
          readonly: "",
          ref: "chi-demos-ins",
          role: "readonlyfield",
          type: "text"
        }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }